const WriteIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4622_12564)">
      <path
        d="M20.9012 9.5252C20.4704 9.1184 19.9172 8.8892 19.3436 8.8772C19.2992 8.876 19.2548 8.8772 19.2116 8.8784V4.2728C19.2116 3.7436 18.7832 3.3152 18.254 3.3152H5.03359C4.50439 3.3152 4.07599 3.7436 4.07599 4.2728V20.726C4.07599 21.2552 4.50439 21.6836 5.03359 21.6836H18.254C18.7832 21.6836 19.2116 21.2552 19.2116 20.726V14.6216L21.0908 12.6296C21.8972 11.7764 21.812 10.3844 20.9012 9.5252ZM17.6792 20.1524H5.60839V4.8476H17.6792V9.6332L13.4768 14.0864C13.352 14.2184 13.2608 14.3732 13.2032 14.546L12.0764 17.9612C12.0301 18.1016 12.0254 18.2524 12.0629 18.3955C12.1003 18.5385 12.1784 18.6677 12.2876 18.7673C12.3968 18.867 12.5325 18.933 12.6783 18.9573C12.8242 18.9816 12.974 18.9633 13.1096 18.9044L16.3676 17.4908C16.5212 17.4236 16.658 17.3288 16.7732 17.2076L17.6792 16.2464V20.1524ZM19.976 11.5784L19.2116 12.3884L17.6792 14.0132L15.7004 16.1096L14.0684 16.8188L14.6384 15.0896L17.6792 11.8676L18.9056 10.568C19.0004 10.4672 19.118 10.4288 19.2128 10.4156C19.2524 10.4096 19.2872 10.4084 19.3148 10.4096C19.5068 10.4132 19.6976 10.4948 19.8512 10.64C20.1404 10.9136 20.198 11.3432 19.976 11.5784Z"
        fill="#575BFD"
      />
      <path
        d="M7.67599 9.152H15.596C16.0196 9.152 16.364 8.8076 16.364 8.384C16.364 7.9604 16.0196 7.616 15.596 7.616H7.67599C7.4723 7.616 7.27696 7.69692 7.13293 7.84094C6.9889 7.98497 6.90799 8.18031 6.90799 8.384C6.90799 8.58769 6.9889 8.78303 7.13293 8.92706C7.27696 9.07109 7.4723 9.152 7.67599 9.152ZM13.964 11.984C13.964 11.5604 13.6196 11.216 13.196 11.216H7.67599C7.25239 11.216 6.90799 11.5604 6.90799 11.984C6.90799 12.4076 7.25239 12.752 7.67599 12.752H13.196C13.6196 12.752 13.964 12.4076 13.964 11.984Z"
        fill="#575BFD"
      />
    </g>
    <defs>
      <clipPath id="clip0_4622_12564">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default WriteIcon;
